import svg from './row-svg/realisation.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function RealisationIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" style={{ width: '100%' }} />;
}

export default RealisationIcon;
